export default __webpack_public_path__ + "static/media/twitter.c37aa0d1.svg";